module.exports = __webpack_public_path__ + "media/16.8e36e018.mp3";